<template>
  <div class="vip vipbuy pt20 pl24 pb30">
    <div class="box1 df aic pl24 pt50 pb50 por bdrd8 b_vip c_vip mr24">
      <img v-if="account.photo" :src="account.photo" alt="" class="all88 bdrd50p">
      <img v-else src="./assets/img/p.png" alt="" class="all88 bdrd50p">
      <div class="pl24 por z1">
        <div class="fz28">{{account.nickname}}</div>
        <div v-if="account.huiyuan_expire_at_sub" class="ico df aic">
          <img src="./assets/img/vip_1.png" alt="" class="w28 h25 mr10">
          年费会员有效期至{{account.huiyuan_expire_at_sub}}
        </div>
        <div v-else>您还未开通年费会员</div>
      </div>
    </div>
    <div class="pt60 df">
      <div @click="choose(v)" v-for="(v,k) in list" :class="cur==v.id?'cur':''" class="item bdrd8 tac pt30 pb30 mr24">
        <div class="t1 fz30">{{v.title}}</div>
        <div class="t2 fz26">￥<span class="fz40">{{v.price}}</span></div>
        <div class="fz28 c_999">{{v.money}}元/年</div>
      </div>
    </div>
    <div @click="submit" class="mt24 b_vip c_vip tac bdrd50 pt20 pb20 fz28 mr24">
      <span v-if="account.huiyuan_expire_at">续费会员</span>
      <span v-else>立即开通</span>
    </div>
    <div class="mt22 df aic jcc fz28 mr24">
      <div @click="check=!check" class="pr12 all36 ovh">
        <img v-if="check" src="./assets/img/ok_h.png" alt="" class="all36">
        <img v-else src="./assets/img/ok.png" alt="" class="all36">
      </div>
      <router-link :to="{ name: 'protocol' ,query:{id:4}}" class="c_vip">《衣印会员协议》</router-link>
      <router-link :to="{ name: 'protocol' ,query:{id:5}}" class="c_vip">《价格说明》</router-link>
    </div>
  </div>
</template>
<script>
import infiniteScroll from '@/basic/infiniteScroll'
export default {
  directives: { infiniteScroll },
  data() {
    return {
      account: {},
      list: [],
      cur: 0,
      money: 0,
      check: false
    }
  },
  mounted() {
    this.getAccount();
  },
  methods: {
    getAccount() {
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
        vm.account.huiyuan_expire_at_sub = vm.account.huiyuan_expire_at.substr(0, 10);
        vm.getHuiyuan();
      })
    },
    getHuiyuan(flag) {
      let vm = this;
      vm.ajax("huiyuan", "get", '', e => {
        vm.list = e.data;
        if (vm.list.length > 0) {
          vm.cur = vm.list[0].id;
          vm.money = vm.list[0].money;
        }
      })
    },
    choose(v) {
      this.cur = v.id;
      this.money = v.money;
    },
    submit() {
      let vm = this;
      if (!vm.check) {
        vm.publics.message.danger('请阅读并同意会员协议');
        return false;
      }
      vm.order({ "id": vm.cur })

      // vm.ajax("huiyuan/buy", "post", {id:vm.cur}, e => {
      //   vm.getAccount();
      // })
    },
    order(data) {
      let vm = this;
      var data = JSON.stringify(data);
      var xhr = new XMLHttpRequest();
      xhr.withCredentials = true;

      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === this.DONE) {
          console.log(this.responseText);

          /* var req = JSON.parse(this.responseText); */
          let response = JSON.parse(this.response);

          if (response.code != 1000) {
            alert(response.error)
          } else {

            // ----- pay weixin ---
            var req = response.data;
            console.log(req);

            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
            } else {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', req,
                function (res) {
                  if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                      // alert("ok")
                      vm.publics.message.success('购买成功，请查看');
                      vm.getAccount();
                    } else {
                      // alert("error")
                      //支付失败/或取消支付跳转页面
                    }
                  }
                });
            }

            // -- pay end --
          }


        }

      });

      xhr.open("POST", vm.publics.API_URL + "huiyuan/buy");
      xhr.setRequestHeader("content-type", "application/json");

      xhr.send(data);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/vipbuy.vue